module.exports = __webpack_public_path__ + "assets/img/00000.24c3e2df.png";